var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFishing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 23,
    viewBox: "0 0 41 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.063 0.66188C16.8151 0.66188 11.3588 4.46534 8.32203 7.7195L2.25746 3.13271C1.4151 2.49521 0.157466 3.17438 0.372743 4.15076L2.05191 11.773L0.372049 19.3959C0.156771 20.3723 1.41441 21.0507 2.25677 20.4139L8.32134 15.8271C11.3581 19.0806 16.8151 22.8841 23.063 22.8841C32.6088 22.8841 40.3477 13.9952 40.3477 11.773C40.3477 9.55075 32.6088 0.66188 23.063 0.66188ZM29.1345 13.4396C28.2143 13.4396 27.4678 12.6931 27.4678 11.773C27.4678 10.8521 28.2143 10.1063 29.1345 10.1063C30.0553 10.1063 30.8011 10.8521 30.8011 11.773C30.8011 12.6931 30.0546 13.4396 29.1345 13.4396Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishing);
export default __webpack_public_path__ + "static/media/fishing.e0bd7a6a307ffd36c30f7f994f4eade5.svg";
export { ForwardRef as ReactComponent };